export default {
  getIdCreditCard: function (state) {
    return state.idCreditCard
  }
}
